import React from 'react';
import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import CardHeader from '@mui/material/CardHeader';
import Typography from "@mui/material/Typography";
import IconButton from '@mui/material/IconButton';
import MoreVertIcon from '@mui/icons-material/MoreVert';
import CardActions from '@mui/material/CardActions';

import { useLoaderData, useNavigation } from "react-router-dom";
import { API } from '@aws-amplify/api';
import Invite from '../Invite/invite';
import CloudId from '../CloudId/cloudid';
import {Users} from '../Users/users';
import MyForm from '../Self/MyForm';

export const settingsLoader = async () => {
  console.log("inside settingsLoader");
  const apiName = 'apic48d2c9b' // was 'api60cb0321';
  const path = "/settings" //+ ucs.customer.name.customer_id;
  const myInit = {
    headers: {'Content-Type':'application/json'}, 
      response: true
    };
    var response = await API.get(apiName, path, myInit);
  return await response.data;
}

export function Settings({ucs}) {
  console.log('propped into Settings function this prop for ucs', ucs);  
  var settings = useLoaderData();
  console.log('settings loaded', settings);
  const navigation = useNavigation();
  
  if (navigation.state === "loading") {
    return <div><h1>Loading Settings...</h1></div>
  }

  console.log('from the dataloader inside settings', settings);

  return (
  <div>

    <Card sx={{ maxWidth: 1024, minWidth: 640,  backgroundColor: "grey"}} variant="outlined" >
      <CardHeader
        action={
          <IconButton aria-label="self-manage">
            <MoreVertIcon />
          </IconButton>
        }
        title =  "Self settings"
        subheader = "Manage your own personal contact information"
      />
      <CardContent>
        <MyForm />

      </CardContent>
    </Card>

    <Card sx={{maxWidth: 1024, minWidth: 640,  backgroundColor: "orange"}} variant="outlined" >
      <CardHeader
        action={
          <IconButton aria-label="settings">
            <MoreVertIcon />
          </IconButton>
        }
        title =  "Fleet of Things Cloud Id setting"
        subheader = "uhc Switch Credential"
      />
      <CardContent>
        <Typography variant="h6" component="div">
        <CloudId ucs={ucs} ></CloudId>
        </Typography>
      </CardContent>
    </Card>

    <Card sx={{ maxWidth: 1024, minWidth: 640,  backgroundColor: "#c4c11b" }} variant="outlined" >
      <CardHeader
        action={
          <IconButton aria-label="settings">
            <MoreVertIcon />
          </IconButton>
        }
        title =  "User settings"
        subheader = "manage user capabilities"
      />
      <CardContent>
        <Users setting_info={settings}/>
      </CardContent>
    </Card>

    <Card sx={{ maxWidth: 1024, minWidth: 640,  backgroundColor: "#FFD580"}} variant="outlined" >
      <CardHeader
        action={
          <IconButton aria-label="Invites">
            <MoreVertIcon />
          </IconButton>
        }
        title =  "Pending Invitations"
        subheader = "Manage the company invites."
      />

      <CardContent>   
        <Invite props={settings}></Invite>
      </CardContent>
    </Card>

  </div>
  ) ;
}
